/**
 * A global namespace for `scrollWidth` property.
 */
const scrollWidth = 'scrollWidth';
export default scrollWidth;
